export default "__VITE_ASSET__Ctcm8POR__"